/**
 * Settings slice for the application store.
 * Handles user preferences and application settings.
 */

import type { StateCreator } from 'zustand';

/**
 * Settings state and actions.
 */
export interface SettingsSlice {
  // State
  settings: Record<string, string>;
  isSettingsLoaded: boolean;

  // Actions
  setSettings: (settings: Record<string, string>) => void;
  setSetting: (key: string, value: string) => void;
  setIsSettingsLoaded: (loaded: boolean) => void;
}

/**
 * Creates the settings slice.
 */
export const createSettingsSlice: StateCreator<SettingsSlice, [], [], SettingsSlice> = set => ({
  // Initial state
  settings: {},
  isSettingsLoaded: false,

  // Actions
  setSettings: settings => set({ settings }),

  setSetting: (key, value) =>
    set(state => ({
      settings: { ...state.settings, [key]: value },
    })),

  setIsSettingsLoaded: loaded => set({ isSettingsLoaded: loaded }),
});

/**
 * Helper to get a setting value from the store.
 * Must be called outside of React components or in effects.
 */
